import React, { useMemo } from 'react'
import NiceModal from '@ebay/nice-modal-react'
import { Routes, useLocation } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { usePersistentWebsocketConnection } from './logic/websockets/usePersistentWebsocketConnection'
import Loading from './Pages/Loading'
import { generateRoutes } from './Pages/navigation'
import { useRedirectLoggedOut } from './utils/redirect/useLogoutRedirect'
import AppBar from './Views/AppBar/AppBar'
import { Copyright } from './Views/Copyright/Copyright'
import { useRefreshAuthToken } from './utils/useRefreshAuthToken'
import { useAppVersion } from './state/hooks/useAppVersion'

export default () => {
	const path = useLocation().pathname
	const routes = useMemo(() => generateRoutes(), [])
	const isPrepareGameVideoPage = path === '/prepare-game-video'
	const isGamePage = path === '/game'
	const isLoading = path === '/loading'
	const isLoggedIn = path !== '/'
	const isForgot = path.startsWith('/forgot-password')
	const isRegistrationPage = path === '/registration/credentials' || path === '/registration/confirmation/email'
	const isPublicGames = path.startsWith('/public')
	const showAppBar = isLoggedIn && !isPrepareGameVideoPage && !isGamePage && !isLoading && !isRegistrationPage && !isForgot && !isPublicGames
	const showCopyright = !isGamePage && !isLoading && path !== '/lobby' && !isPublicGames

	useAppVersion()
	useRefreshAuthToken()
	usePersistentWebsocketConnection()
	useRedirectLoggedOut()

	return (
		<div id='App'>
			<div id='page-container'>
				{showAppBar && <AppBar />}
				<React.Suspense fallback={<Loading />}>
					<NiceModal.Provider>
						<Routes>{routes}</Routes>
					</NiceModal.Provider>
				</React.Suspense>
				{showCopyright && <Copyright />}
			</div>
			<Toaster position='top-center' />
		</div>
	)
}
